import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
import { useEsigningRecipients } from 'app/domains/esigning/hooks/useEsigningRecipients';
import { useEsigningSettings } from 'app/domains/esigning/hooks/useEsigningSettings';
export function SigningOrderAlert() {
    const { signerRecipients } = useEsigningRecipients();
    const { requireOrder } = useEsigningSettings();
    const undefinedOrder = requireOrder && signerRecipients.some(({ order }) => order === undefined);
    const invalidOrder = requireOrder && signerRecipients.some(({ order }) => order !== undefined && order >= signerRecipients.length);
    if (invalidOrder) {
        return (<Alert appearance="warning" title={t({
                comment: 'Alert title for when the user has selected set signing order and selected an order for all signing parties, but the order is invalid',
                message: `A signing party's order is out of range`,
            })} message={t({
                comment: 'Alert message for when the user has selected set signing order and selected an order for all signing parties, but the order is invalid',
                message: 'Please change the signing order to continue',
            })}/>);
    }
    if (undefinedOrder) {
        return (<Alert appearance="info" title={t({
                comment: 'Alert title for when the user has selected set signing order and not selected an order for all signing parties',
                message: 'A signing party is missing its signing order',
            })} message={t({
                comment: 'Alert message for when the user has selected set signing order and not selected an order for all signing parties',
                message: 'Please set the signing order to continue',
            })}/>);
    }
    return null;
}
